


























































import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { AsyncUtility } from "../../../utilities";
import { ISystemDateSelectorCustomButtonConfiguration } from "../../../domain/configuration";
import FuzzyDateSelectButton from "../../document/editor/objects/dialogs/FuzzyDateSelectButton.vue";
import { DateSelectableMixin } from "./mixins";
import YearAsJapaneseCalendarEditor from "./YearAsJapaneseCalendarEditor.vue";
import DateEditor from "./DateEditor.vue";
import DateCalendarSelector from "./DateCalendarSelector.vue";

interface IDirectButtonDefinable {
  label: string;
  value: Date | string | (() => Date) | (() => string);
}

interface IDirectButtonsDefinable {
  minWidth: string;
  buttons: IDirectButtonDefinable[];
}

@Component({
  components: {
    YearAsJapaneseCalendarEditor,
    DateEditor,
    DateCalendarSelector,
    FuzzyDateSelectButton
  }
})
export default class DateSelector extends Mixins(DateSelectableMixin) {
  $refs!: {
    yearAsJapaneseCalendar: YearAsJapaneseCalendarEditor;
    dateEditor: DateEditor;
    dateCalendarSelector: DateCalendarSelector;
  };

  async onEnterKeyDown() {
    // TODO: fix だいぶしんどい対応している模様
    this.$refs.dateCalendarSelector.$refs.table.focus();
    // 入力した値が確定されるのを待つ
    await this.$nextTick();
    await AsyncUtility.sleep(1);
    this.applyValue(this.editingSource);
  }

  async setFocus(): Promise<void> {
    // 起動時に和暦プルダウンにフォーカスを当てたい
    // 起動直後にフォーカスを当てるとDateObjectにフォーカスを取られることがあるので
    // 少し待ってからプルダウンにフォーカスを当てる
    await AsyncUtility.sleep(1);
    if (this.isJapaneseCalendarEditable && this.$refs.yearAsJapaneseCalendar) {
      this.$refs.yearAsJapaneseCalendar.setFocus();
    } else if (!this.isJapaneseCalendarEditable && this.$refs.dateEditor) {
      this.$refs.dateEditor.setYearSelectorFocus();
    }
  }

  get directDateButtons(): IDirectButtonsDefinable[] {
    return [
      {
        minWidth: "70px",
        buttons: [
          {
            label: "月初",
            value: this.firstDayOfThisMonth,
          },
          {
            label: "月末",
            value: this.lastDayOfThisMonth,
          },
          {
            label: "年初",
            value: this.firstDayOfThisYear,
          },
          {
            label: "年末",
            value: this.lastDayOfThisYear,
          },
        ],
      },
    ];
  }

  get isCustomButtonEnable(): boolean {
    return this.customButtons && this.customButtons.length > 0;
  }

  get customButtons(): ISystemDateSelectorCustomButtonConfiguration[] {
    return this.$configuration.system.dateSelector.customButtons;
  }

  get directDateCustomButtons(): IDirectButtonsDefinable[] {
    return [
      {
        minWidth: "70px",
        buttons: Enumerable.from(this.customButtons).select(b => this.toDirectDateButton(b)).toArray(),
      },
    ];
  }

  private toDirectDateButton(configuration: ISystemDateSelectorCustomButtonConfiguration): IDirectButtonDefinable {
    return {
      label: configuration.label,
      value: this.toDirectDateButtonValue(configuration),
    };
  }

  private toDirectDateButtonValue(configuration: ISystemDateSelectorCustomButtonConfiguration): Date {
    const date = this.now();
    if (configuration.parameters.year) {
      date.setFullYear(date.getFullYear() + configuration.parameters.year);
    }
    if (configuration.parameters.month) {
      date.setMonth(date.getMonth() + configuration.parameters.month);
    }
    if (configuration.parameters.day) {
      date.setDate(date.getDate() + configuration.parameters.day);
    }
    return date;
  }
}
